import { render, staticRenderFns } from "./draftsDialog.vue?vue&type=template&id=32ebe052&scoped=true"
import script from "./draftsDialog.vue?vue&type=script&lang=js"
export * from "./draftsDialog.vue?vue&type=script&lang=js"
import style0 from "./draftsDialog.vue?vue&type=style&index=0&id=32ebe052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ebe052",
  null
  
)

export default component.exports